module.exports = __webpack_public_path__ + "static/media/ifood-logo.807fcd77.PNG";